module.exports = __webpack_public_path__ + "static/media/zheng.bc98f483.png";


//////////////////
// WEBPACK FOOTER
// ./src/authCertificateCompact/modules/papersUpload_GR/image/zheng.png
// module id = 901
// module chunks = 0